/**
 * The initial value of Symbol.split is the well-known symbol @@split
 * https://tc39.es/ecma262/#sec-symbol.split
 */
export const symbolSplit = () => Symbol("Symbol.split");
